import React, { useState } from 'react';
import Swal from "sweetalert2/dist/sweetalert2.js";
import Preloader from '../../../../GeneralComponents/LoadingComponen';

const QUESTION_TYPES = [
    "answer_string", "answer_text", "answer_integer", "answer_formula",
    "answer_select", "answer_radio", "answer_checkbox", "answer_file",
    "answer_date", "answer_hour", "answer_user_id", "answer_matrix",
    "answer_autoincrementable", "answer_localization", "answer_signature",
    "position_id", "proceso_id", "format_id", "answer_subform",
    "code_format", "answer_select_tree", "answer_formula_date",
    "answer_dynamic_field", "answer_table", "answer_image", "answer_video",
    "answer_audio"
];

const Index = () => {
    const [formatId, setFormatId] = useState("");
    const [formatName, setFormatName] = useState("");
    const [data, setData] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const [showFilters, setShowFilters] = useState(false);

    const [dateDeleteFrom, setDateDeleteFrom] = useState("");
    const [dateDeleteTo, setDateDeleteTo] = useState("");
    const [questionType, setQuestionType] = useState("");

    const token = document.querySelector("[name='csrf-token']").content;

    const buildFilterParams = () => {
        let params = "";
        if (dateDeleteFrom) params += `&date_delete_from=${dateDeleteFrom}`;
        if (dateDeleteTo) params += `&date_delete_to=${dateDeleteTo}`;
        if (questionType) params += `&question_type=${questionType}`;
        return params;
    }

    const loadData = () => {
        if (!formatId) {
            Swal.fire({ position: "center", type: "warning", title: "Ingrese un ID de formato", showConfirmButton: false, timer: 1500 });
            return;
        }

        setIsLoaded(true);
        setHasSearched(true);

        fetch(`/settings/get_recovery_questions?format_id=${formatId}${buildFilterParams()}`, {
            method: 'GET',
            headers: { "X-CSRF-Token": token, "Content-Type": "application/json" }
        })
        .then(response => response.json())
        .then(response => {
            setData(response.data);
            setFormatName(response.format_name || "");
            setIsLoaded(false);
        });
    }

    const clearFilters = () => {
        setDateDeleteFrom("");
        setDateDeleteTo("");
        setQuestionType("");
    }

    const handleRestore = (question) => {
        Swal.fire({
            title: "Restaurar pregunta?",
            text: `Se restaurara la pregunta: ${question.question}`,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, restaurar",
            cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.value) {
                fetch(`/settings/restore_question/${question.id}`, {
                    method: 'POST',
                    headers: { "X-CSRF-Token": token, "Content-Type": "application/json" }
                })
                .then(response => response.json())
                .then(response => {
                    if (response.type === "success") {
                        setData(data.filter(item => item.id !== question.id));
                        Swal.fire({ position: "center", type: "success", title: response.success, showConfirmButton: false, timer: 1500 });
                    }
                });
            }
        });
    }

    const dateTime = (fecha) => {
        if (!fecha) return "N/A";
        var d = new Date(fecha);
        var months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        return months[d.getMonth()] + " " + d.getDate() + " del " + d.getFullYear() + " / " + d.getHours() + ":" + (d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes());
    }

    return (
        <React.Fragment>
            <div className="row mb-3">
                <div className="col-md-3">
                    <label>ID del Formato</label>
                    <input
                        type="number"
                        className="form-control"
                        placeholder="Ingrese el ID del formato"
                        value={formatId}
                        onChange={(e) => setFormatId(e.target.value)}
                        onKeyPress={(e) => { if (e.key === 'Enter') loadData(); }}
                    />
                </div>
                <div className="col-md-2 d-flex align-items-end">
                    <button className="btn btn-shadow btn-info" onClick={() => loadData()}>
                        <i className="fas fa-search mr-1"></i> Buscar
                    </button>
                </div>
                {formatName && (
                    <div className="col-md-4 d-flex align-items-end">
                        <h5 className="mb-1">Formato: <strong>{formatName}</strong></h5>
                    </div>
                )}
                {hasSearched && (
                    <div className="col-md-3 d-flex align-items-end justify-content-end">
                        <button className="btn btn-shadow btn-outline-secondary" onClick={() => setShowFilters(!showFilters)}>
                            <i className={`fas ${showFilters ? 'fa-times' : 'fa-filter'} mr-1`}></i> {showFilters ? 'Cerrar filtros' : 'Filtros'}
                        </button>
                    </div>
                )}
            </div>

            {showFilters && (
                <div className="card mb-3">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-3">
                                <label>Fecha eliminacion desde</label>
                                <input type="date" className="form-control" value={dateDeleteFrom} onChange={(e) => setDateDeleteFrom(e.target.value)} />
                            </div>
                            <div className="col-md-3">
                                <label>Fecha eliminacion hasta</label>
                                <input type="date" className="form-control" value={dateDeleteTo} onChange={(e) => setDateDeleteTo(e.target.value)} />
                            </div>
                            <div className="col-md-3">
                                <label>Tipo de pregunta</label>
                                <select className="form-control" value={questionType} onChange={(e) => setQuestionType(e.target.value)}>
                                    <option value="">Todos</option>
                                    {QUESTION_TYPES.map(type => (
                                        <option key={type} value={type}>{type}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-3 d-flex align-items-end">
                                <button className="btn btn-shadow btn-info mr-2" onClick={() => loadData()}>
                                    <i className="fas fa-search mr-1"></i> Aplicar
                                </button>
                                <button className="btn btn-shadow btn-outline-danger" onClick={() => { clearFilters(); }}>
                                    <i className="fas fa-times mr-1"></i> Limpiar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isLoaded && <Preloader />}

            {!isLoaded && hasSearched && (
                <React.Fragment>
                    {data.length >= 1 ? (
                        <table className="table table-hover table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Pregunta</th>
                                    <th>Tipo</th>
                                    <th>Posicion</th>
                                    <th>Eliminada por</th>
                                    <th>Fecha eliminacion</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map(question => (
                                    <tr key={question.id}>
                                        <td>{question.id}</td>
                                        <td>{question.question}</td>
                                        <td><span className="badge badge-info">{question.question_type}</span></td>
                                        <td>{question.position}</td>
                                        <td>{question.user_delete ? question.user_delete.name : "N/A"}</td>
                                        <td>{dateTime(question.date_delete)}</td>
                                        <td>
                                            <button
                                                className="btn btn-shadow btn-sm btn-success"
                                                onClick={() => handleRestore(question)}
                                            >
                                                <i className="fas fa-undo"></i> Restaurar
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className="card">
                            <div className="card-body text-center">
                                <h5>No hay preguntas eliminadas para este formato</h5>
                            </div>
                        </div>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default Index;
